import { useSelector } from "react-redux";
import { getRoleList, getOrgList } from "src/store/slice/model/Admin/AdminCommon";
import store from "src/storeWire";
import { isEqual } from "underscore";

export function useAdminCommonStore() {
    const roleList = useSelector((state) => state.entities.model_Admin_Common.roleList, isEqual)
    const orgList = useSelector((state) => state.entities.model_Admin_Common.orgList, isEqual)
    const roleListMessage = useSelector((state) => state.entities.model_Admin_Common.roleListMessage)
    const orgListMessage = useSelector((state) => state.entities.model_Admin_Common.orgListMessage)


    let data = {
        roleList,
        roleListMessage,
        orgList,
        orgListMessage
    };

    let fetch = {
        get_role_list: async () => {
            return await store.dispatch(getRoleList())
        },
        get_organization_detail: async () => {
            return await store.dispatch(getOrgList())
        },
        // get_export_user_url: async (params) => {
        //     return await new UserRepository().exportUserList();
        // },

    };
    let set = {

    };
    return [data, fetch, set]
}
